import type { MarketplaceAdministrationState } from "./types";

export const refreshLoadedMarketplaceAdministration = async (
  state: MarketplaceAdministrationState,
) => {
  await Promise.all([
    ...(state.overviewHydrated ? [state.loadOverview(true)] : []),
    ...(state.productsHydrated ? [state.loadProducts(true)] : []),
    ...(state.allowancePoliciesHydrated ? [state.loadAllowancePolicies(true)] : []),
    ...(Object.values(state.opportunityInventories).some((entry) => entry.hydrated) ? [state.refreshOpportunityInventories()] : []),
    ...Object.entries(state.opportunityDetails).filter(([, entry]) => entry.hydrated).map(([opportunityId]) => state.loadOpportunityDetail(opportunityId, { force: true })),
    ...(Object.values(state.productActivities).some((entry) => entry.hydrated) ? [state.refreshProductActivities()] : []),
    ...Object.entries(state.productPricingSalesSummaries)
      .filter(([, entry]) => entry.hydrated)
      .map(([productId]) => state.loadProductPricingSalesSummary(productId, { force: true })),
    ...Object.entries(state.pricingSalesSummaries)
      .filter(([, entry]) => entry.hydrated)
      .map(([ruleId]) => state.loadPricingSalesSummary(ruleId, { force: true })),
    ...Object.values(state.pricingSalesPages)
      .filter((entry) => entry.hydrated)
      .map((entry) => state.loadPricingSales(entry.query, { force: true })),
  ]);
};

export const refreshMarketplaceCatalogMutation = async (
  state: MarketplaceAdministrationState,
) => {
  if (state.overviewHydrated) await state.loadOverview(true);
};

export const refreshMarketplacePricingMutation = async (
  state: MarketplaceAdministrationState,
) => {
  await Promise.all([
    ...(state.productsHydrated ? [state.loadProducts(true)] : []),
    ...(state.overviewHydrated ? [state.loadOverview(true)] : []),
  ]);
};
